import moment from 'moment';

export default {
  data: function () {
    return {};
  },
  computed: {
    uBeforePlanning() {
      if (this.schedules[this.scheduleIndex].events.length === 0) return true;
      return !this.schedules[this.scheduleIndex].events.find(e => e.event_type === 'move');
    },
  },
  methods: {
    /**
     * 独自ドメイン対応。staticコンテンツのドメインを取得します
     * @returns staticコンテンツのドメイン
     */
    uStaticDomain() {
      const uri = new URL(window.location.href);
      const originalDomain = Object.values(process.env.ORIGINAL_DOMAIN_LIST).find((domain) => domain.DOMAIN === uri.hostname);
      return originalDomain ? `https://${originalDomain.DOMAIN}` : process.env.STATIC_DOMAIN;
    },
    /**
     * 独自ドメイン対応。staticコンテンツのURLを取得します
     * @returns staticコンテンツのURL
     */
    uGetStaticFileUrl(url) {
      var uri = new URL(window.location.href);
      const originalDomain = Object.values(process.env.ORIGINAL_DOMAIN_LIST).find((domain) => domain.DOMAIN === uri.hostname);
      return originalDomain ? url.replace(process.env.STATIC_DOMAIN, `https://${originalDomain.DOMAIN}`) : url;
    },
    /**
     * 指定した文字列がキャメルケースの場合、スネークケースへ変換します。
     * https://www.yoheim.net/blog.php?q=20181204 から流用しました。
     * @param str 文字列
     * @returns {string}
     * @private
     */
    toUnderscoreCase(str) {
      return str.split(/(?=[A-Z])/).join('_').toLowerCase();
    },
    /**
     * オブジェクトのキーがキャメルケースの場合、スネークケースへ変換します。
     * javascript では変数名にキャメルケースを利用する一方で、BFF や mocha で利用している Java ではスネークケースを利用しているため、受け渡し時には変換する必要があります。
     * @param obj オブジェクト
     * @returns {{}}
     * @private
     */
    toUnderscoreCaseObject(obj) {
      const result = {};
      Object.keys(obj).forEach(key => {
        result[this.toUnderscoreCase(key)] = obj[key];
      });
      return result;
    },
    /**
     * 指定した文字列がスネークケースの場合、キャメルケースへ変換します。
     * https://www.yoheim.net/blog.php?q=20181204 から流用しました。
     * @param str 文字列
     * @returns {*}
     */
    toCamelCase(str) {
      return str.split('_').map((word, index) => {
        if (index === 0) {
          return word.toLowerCase();
        }
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      }).join('');
    },
    /**
     * オブジェクトのキーがスネークケースの場合、キャメルケースへ変換します。
     * javascript では変数名にキャメルケースを利用する一方で、BFF や mocha で利用している Java ではスネークケースを利用しているため、受け渡し時には変換する必要があります。
     * @param obj
     * @returns {{}}
     */
    toCamelCaseObject(obj) {
      const result = {};
      Object.keys(obj).forEach(key => {
        result[this.toCamelCase(key)] = obj[key];
      });
      return result;
    },
    /**
     * スポット画像を取得する
     */
    uGetImage(spot) {
      if (spot &&
        spot.details &&
        spot.details[0] &&
        spot.details[0].images &&
        spot.details[0].images[0].path) {
        return spot.details[0].images[0].path;
      } else if (spot &&
        spot.userReviewImages &&
        spot.userReviewImages.length > 0) {
        return spot.userReviewImages[0].smallThumbnailPath;
      } else if (spot && spot.mainImage) {
        return spot.mainImage;
      } else if (spot &&
        spot.images &&
        spot.images.length > 0 &&
        spot.images[0]) {
        if (typeof spot.images[0] === 'string') {
          return spot.images[0];
        }
        return spot.images[0].url;
      } else {
        return '';
      }
    },

    /**
     * 一日のスケジュールが 3:00 ~ 27:00 の中に収まっていない場合、True を返す
     * @param schedule.events
     * @private
     */
    _isOverflowOneDay(events, scheduleDate) {
      // 全て true の場合、エラーではないので!で false を返す
      return events.some(e => {
        // 時刻が無いイベントはスルー
        if (!e.start_time || !e.end_time) return true;
        // 3:00 区切りの中に収まっていなかったら true
        return !this.fitsInOneDay(e, scheduleDate);
      });
    },

    /**
     * 指定したイベントが対象とする日付の 3:00 ~ 27:00 の中に収まっているかを判定します。
     * @param event イベント
     * @param scheduleDate 対象とする日付
     * @return {boolean} 指定したイベントが対象とする日付の3:00 ~ 27:00 の中に収まっていれば true
     */
    fitsInOneDay(event, scheduleDate) {
      // 移動情報にエラーがあった場合は false とする
      if (event?.move?.error_type) return false;
      // イベントに時刻情報がない場合は true とする
      if (!event.start_time || !event.end_time) return true;

      // 作成されたスケジュールが 3:00 区切りの中に納まっていないかチェックする
      const m3oClock = moment(scheduleDate).utcOffset(9).set('hour', 3).set('minute', 0);
      const m27oClock = moment(scheduleDate).utcOffset(9).add(1, 'd').set('hour', 3);
      // 3:00 区切りの中に収まっていたら true
      return m3oClock.isSameOrBefore(event.start_time) && m27oClock.isSameOrAfter(event.end_time);
    },

    /**
     * 指定した値 - 1 を最大値とするランダムの整数を取得します。
     * @param max 最大値
     * @returns {number} 最大値 - 1 を最大とするランダムの整数
     */
    getRandomInt(max) {
      return Math.floor(Math.random() * max);
    },
    /**
     * 緯度経度を日本測地系に変換する
     * @param {{lon: int, lat: int}}
     * @returns {{lon: int, lat: int}}
     */
    transWGS2Tokyo() {
      var lonW = arguments[0].lon / 1000.0;
      var latW = arguments[0].lat / 1000.0;
      var RlatW, RlonW;// ラジアン値(WGS)
      var aW, bW;// 赤道半径、極半径、扇平率（WGS系）
      var eW;// 離心率(WGS)
      var N;// ジオイド
      var X, Y, Z;
      var aT, bT; // 赤道半径、極半径、扇平率（東京測地系）
      var eT1, eT2; // 離心率(東京測地系)
      var P, theta; // theta:角度θ
      var RlatT, RlonT; // ラジアン値(Tokyo)
      var KOUDO = 0.0;// 高度
      // 初期化
      aW = 6378137.0;
      bW = 6356752.31424518;
      eW = (aW * aW - bW * bW) / (aW * aW);
      aT = 6377397.155;
      bT = 6356078.963;
      eT1 = (aT * aT - bT * bT) / (aT * aT);
      eT2 = (aT * aT - bT * bT) / (bT * bT);
      // ラジアン値(WGS)
      RlatW = latW * (Math.PI / (180.0 * 3600.0));
      RlonW = lonW * (Math.PI / (180.0 * 3600.0));
      // ジオイド(WGS)
      N = aW / Math.sqrt(1 - eW * Math.sin(RlatW) * Math.sin(RlatW));
      //
      X = (N + KOUDO) * Math.cos(RlatW) * Math.cos(RlonW) - (-147.54);
      Y = (N + KOUDO) * Math.cos(RlatW) * Math.sin(RlonW) - 507.26;
      Z = (N * (1 - eW) + KOUDO) * Math.sin(RlatW) - 680.47;
      //
      P = Math.sqrt(X * X + Y * Y);
      theta = Math.atan((Z * aT) / (P * bT));
      // ラジアン値(Tokyo)
      RlatT = Math.atan2((Z + eT2 * bT * Math.sin(theta) * Math.sin(theta) * Math.sin(theta)), (P - eT1 * aT * Math.cos(theta) * Math.cos(theta) * Math.cos(theta)));
      RlonT = Math.atan2(Y, X);

      // 求める緯度、経度(Tokyo)
      return ({'lon': Math.floor(RlonT * ((180.0 * 3600.0) / Math.PI) * 1000.0), 'lat': Math.floor(RlatT * ((180.0 * 3600.0) / Math.PI) * 1000.0)});
    },
  },
};
